import Layout from '@/layout'

const route = {
  path: '/enterpriseWechat',
  component: Layout,
  redirect: '/enterpriseWechat/index',
  alwaysShow: true, // will always show the root menu
  name: 'enterpriseWechat',
  meta: {
    title: '微信客服',
    icon: 'diy-WzXnKeFu',
    roles: [
      'workWechat'
    ]
  },
  children: [
    // {
    //   path: '/denterpriselinks/denterpriselinksing/index',
    //   component: () => import('@/views/denterpriselinksing/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '微信客服',
    //     // icon: 'component',
    //     roles: [
    //       'workWechat.kf.index'
    //     ]
    //   }
    // },
    {
      path: '/denterpriselinks/denterpriselinksingVersion2/index',
      component: () => import('@/views/denterpriselinksingVersion2/index.vue'),
      name: 'denterpriselinksingVersion2',
      meta: {
        title: '微信客服V2',
        // icon: 'component',
        roles: [
          'workWechat.kf.index'
        ]
      }
    },
    {
      path: '/denterpriselinks/denterpriselinksingVersion3/index',
      component: () => import('@/views/denterpriselinksingVersion3/index.vue'),
      name: 'denterpriselinksingVersion2',
      meta: {
        title: '微信客服V3',
        // icon: 'component',
        roles: [
          'workWechat.kf.index'
        ]
      }
    },
    {
      path: '/tencentAdvertising/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '检测企微',
        roles: [
          'workWechat.monitor'
        ]
      },
      children: [{
        path: '/mobilePhoneList/index',
        component: () => import('@/views/mobilePhoneList/index.vue'),
        name: 'mobilePhoneList',
        meta: {
          title: '手机列表',
          roles: [
            'workWechat.phone.list'
          ]
        }
      },
      {
        path: '/enterpriseWeChatCustomerService/index',
        component: () => import('@/views/enterpriseWeChatCustomerService/index.vue'),
        name: 'enterpriseWeChatCustomerService',
        meta: {
          title: '企业微信客服',
          roles: [
            'workWechat.customer.list'
          ]
        }
      },
      {
        path: '/configurationList/index',
        component: () => import('@/views/configurationList/index.vue'),
        name: 'configurationList',
        meta: {
          title: '配置列表',
          roles: [
            'workWechat.config.list'
          ]
        }
      },
      {
        path: '/errorList/index',
        component: () => import('@/views/errorList/index.vue'),
        name: 'errorList',
        meta: {
          title: '异常列表',
          roles: [
            'workWechat.error.list'
          ]
        }
      }]
    }

    // {
    //   path: '/luckdraw/index',
    //   component: () => import('@/views/luckDraw/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '转盘',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    // {
    //   path: '/appletsconfigure/index',
    //   component: () => import('@/views/appletsconfigure/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '小程序绑定配置信息',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    // {
    //   path: '/appletedition/index',
    //   component: () => import('@/views/appletedition/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '小程序版本提交',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    // {
    //   path: '/wechattemplateme/index',
    //   component: () => import('@/views/wechattemplateme/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '微信模板消息',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // },
    // {
    //   path: '/turntableadvertisement/index',
    //   component: () => import('@/views/turntableadvertisement/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '小程序广告',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // }
    // {
    //   path: '/winprize/index',
    //   component: () => import('@/views/winprize/index.vue'),
    //   name: 'timedPush',
    //   meta: {
    //     title: '中奖记录',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   },
    //   hidden: true
    // }
    // {
    //   path: '/merchantpay/merchantpaying/index',
    //   component: () => import('@/views/merchantpaying/index.vue'),
    //   name: 'sourceMaterial',
    //   meta: {
    //     title: '商户号支付',
    //     icon: 'component',
    //     roles: [
    //       'message.templateList'
    //     ]
    //   }
    // }
  ]
}

export default route
